import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[onlyInteger]',
})
export class OnlyIntegerDirective {
  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event.target.value'])
  onInputChange(value: string) {
    const regex = /^[0-9]*$/;
    if (!regex.test(value)) {
      this.el.nativeElement.value = value.replace(/[^0-9]/g, '');
    }
  }
}
